import { createFeatureSelector, createSelector } from '@ngrx/store';
import { memoize } from 'lodash';
import { GenesysCloudFeatureTogglesState } from '../genesys-cloud-feature-toggles.state';
import { featureKey } from '../reducers/feature-key';
import { FeatureToggles } from '../model/feature-toggles.model';

export const selectState = createFeatureSelector<GenesysCloudFeatureTogglesState>(featureKey);

export const selectFeatureToggle = memoize((featureToggle?: FeatureToggles) =>
  createSelector(selectState, (state) => state.featureToggles[featureToggle] || false)
);

export const selectAllFeatureToggles = () => createSelector(selectState, (state) => state.featureToggles);
